import React from 'react';
import Svg from 'rp-react-svg-icon';

/**
 * Spinner presentation component
 * Indicates loading state.
 * Should be included manually as it doesn't depends from state
 */
export default function Spinner() {
    return (
        <div className="search-tabContent__spinner">
            <Svg
                className="ui-animation_spinnerAnimation"
                size="2XL"
                iconName="spinner"
            />
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/js/Common/Spinner.jsx